import 'Modules/@apostrophecms/ui/scss/global/import-all.scss';
import Vue from 'Modules/@apostrophecms/ui/lib/vue';
window.apos.bus = new Vue();import AccountBoxIcon from 'vue-material-design-icons/AccountBox.vue';
import AlphaXIcon from 'vue-material-design-icons/AlphaX.vue';
import AlertCircleIcon from 'vue-material-design-icons/AlertCircle.vue';
import ArrowDownIcon from 'vue-material-design-icons/ArrowDown.vue';
import ArrowUpIcon from 'vue-material-design-icons/ArrowUp.vue';
import ArchiveArrowDownIcon from 'vue-material-design-icons/ArchiveArrowDown.vue';
import ArchiveArrowUpIcon from 'vue-material-design-icons/ArchiveArrowUp.vue';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import CalendarIcon from 'vue-material-design-icons/Calendar.vue';
import CheckboxBlankOutlineIcon from 'vue-material-design-icons/CheckboxBlankOutline.vue';
import CheckAllIcon from 'vue-material-design-icons/CheckAll.vue';
import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
import CheckCircleIcon from 'vue-material-design-icons/CheckCircle.vue';
import CheckDecagramIcon from 'vue-material-design-icons/CheckDecagram.vue';
import CheckboxMarkedIcon from 'vue-material-design-icons/CheckboxMarked.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import ChevronLeftIcon from 'vue-material-design-icons/ChevronLeft.vue';
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue';
import CircleIcon from 'vue-material-design-icons/Circle.vue';
import CircleMediumIcon from 'vue-material-design-icons/CircleMedium.vue';
import ClockIcon from 'vue-material-design-icons/Clock.vue';
import CloseCircleIcon from 'vue-material-design-icons/CloseCircle.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import CloudUploadIcon from 'vue-material-design-icons/CloudUpload.vue';
import CodeTagsIcon from 'vue-material-design-icons/CodeTags.vue';
import CogIcon from 'vue-material-design-icons/Cog.vue';
import CursorDefaultClickIcon from 'vue-material-design-icons/CursorDefaultClick.vue';
import ContentCopyIcon from 'vue-material-design-icons/ContentCopy.vue';
import ClipboardPlusIcon from 'vue-material-design-icons/ClipboardPlus.vue';
import ClipboardPlusOutlineIcon from 'vue-material-design-icons/ClipboardPlusOutline.vue';
import DeleteIcon from 'vue-material-design-icons/Delete.vue';
import ContentCutIcon from 'vue-material-design-icons/ContentCut.vue';
import DotsVerticalIcon from 'vue-material-design-icons/DotsVertical.vue';
import AppsIcon from 'vue-material-design-icons/Apps.vue';
import EyeIcon from 'vue-material-design-icons/Eye.vue';
import FileTreeIcon from 'vue-material-design-icons/FileTree.vue';
import FileDocumentIcon from 'vue-material-design-icons/FileDocument.vue';
import FlareIcon from 'vue-material-design-icons/Flare.vue';
import FormatAlignCenterIcon from 'vue-material-design-icons/FormatAlignCenter.vue';
import FormatAlignJustifyIcon from 'vue-material-design-icons/FormatAlignJustify.vue';
import FormatAlignLeftIcon from 'vue-material-design-icons/FormatAlignLeft.vue';
import FormatAlignRightIcon from 'vue-material-design-icons/FormatAlignRight.vue';
import FormatBoldIcon from 'vue-material-design-icons/FormatBold.vue';
import FormatListBulletedIcon from 'vue-material-design-icons/FormatListBulleted.vue';
import FormatListNumberedIcon from 'vue-material-design-icons/FormatListNumbered.vue';
import FormatItalicIcon from 'vue-material-design-icons/FormatItalic.vue';
import FormatStrikethroughVariantIcon from 'vue-material-design-icons/FormatStrikethroughVariant.vue';
import FormatUnderlineIcon from 'vue-material-design-icons/FormatUnderline.vue';
import FormatQuoteCloseIcon from 'vue-material-design-icons/FormatQuoteClose.vue';
import HelpCircleIcon from 'vue-material-design-icons/HelpCircle.vue';
import InformationOutlineIcon from 'vue-material-design-icons/InformationOutline.vue';
import InformationIcon from 'vue-material-design-icons/Information.vue';
import ImageIcon from 'vue-material-design-icons/Image.vue';
import ImageSizeSelectActualIcon from 'vue-material-design-icons/ImageSizeSelectActual.vue';
import PlayBoxIcon from 'vue-material-design-icons/PlayBox.vue';
import InstagramIcon from 'vue-material-design-icons/Instagram.vue';
import LabelIcon from 'vue-material-design-icons/Label.vue';
import LightbulbOnIcon from 'vue-material-design-icons/LightbulbOn.vue';
import LinkIcon from 'vue-material-design-icons/Link.vue';
import ListStatusIcon from 'vue-material-design-icons/ListStatus.vue';
import LockIcon from 'vue-material-design-icons/Lock.vue';
import MapMarkerIcon from 'vue-material-design-icons/MapMarker.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import MenuDownIcon from 'vue-material-design-icons/MenuDown.vue';
import MinusIcon from 'vue-material-design-icons/Minus.vue';
import MinusBoxIcon from 'vue-material-design-icons/MinusBox.vue';
import PaperclipIcon from 'vue-material-design-icons/Paperclip.vue';
import PencilIcon from 'vue-material-design-icons/Pencil.vue';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import PhoneIcon from 'vue-material-design-icons/Phone.vue';
import RedoVariantIcon from 'vue-material-design-icons/RedoVariant.vue';
import RefreshIcon from 'vue-material-design-icons/Refresh.vue';
import SignTextIcon from 'vue-material-design-icons/SignText.vue';
import TextBoxRemoveIcon from 'vue-material-design-icons/TextBoxRemove.vue';
import TrashCanIcon from 'vue-material-design-icons/TrashCan.vue';
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import TuneIcon from 'vue-material-design-icons/Tune.vue';
import UndoVariantIcon from 'vue-material-design-icons/UndoVariant.vue';
import UnfoldMoreHorizontalIcon from 'vue-material-design-icons/UnfoldMoreHorizontal.vue';
import VideoIcon from 'vue-material-design-icons/Video.vue';
import ViewColumnIcon from 'vue-material-design-icons/ViewColumn.vue';
import WebIcon from 'vue-material-design-icons/Web.vue';
import DatabaseExportIcon from 'vue-material-design-icons/DatabaseExport.vue';
import FormatTextIcon from 'vue-material-design-icons/FormatText.vue';
import FormatColorHighlightIcon from 'vue-material-design-icons/FormatColorHighlight.vue';
import EarthIcon from 'vue-material-design-icons/Earth.vue';
import DatabaseCheckIcon from 'vue-material-design-icons/DatabaseCheck.vue';
import TrayFullIcon from 'vue-material-design-icons/TrayFull.vue';

                Vue.component('account-box-icon', AccountBoxIcon);
Vue.component('alpha-x-icon', AlphaXIcon);
Vue.component('alert-circle-icon', AlertCircleIcon);
Vue.component('arrow-down-icon', ArrowDownIcon);
Vue.component('arrow-up-icon', ArrowUpIcon);
Vue.component('archive-arrow-down-icon', ArchiveArrowDownIcon);
Vue.component('archive-arrow-up-icon', ArchiveArrowUpIcon);
Vue.component('arrow-right-icon', ArrowRightIcon);
Vue.component('calendar-icon', CalendarIcon);
Vue.component('checkbox-blank-icon', CheckboxBlankOutlineIcon);
Vue.component('check-all-icon', CheckAllIcon);
Vue.component('check-bold-icon', CheckBoldIcon);
Vue.component('check-circle-icon', CheckCircleIcon);
Vue.component('check-decagram-icon', CheckDecagramIcon);
Vue.component('checkbox-marked-icon', CheckboxMarkedIcon);
Vue.component('chevron-down-icon', ChevronDownIcon);
Vue.component('chevron-left-icon', ChevronLeftIcon);
Vue.component('chevron-right-icon', ChevronRightIcon);
Vue.component('chevron-up-icon', ChevronUpIcon);
Vue.component('circle-icon', CircleIcon);
Vue.component('circle-medium-icon', CircleMediumIcon);
Vue.component('clock-icon', ClockIcon);
Vue.component('close-circle-icon', CloseCircleIcon);
Vue.component('close-icon', CloseIcon);
Vue.component('cloud-upload-icon', CloudUploadIcon);
Vue.component('code-tags-icon', CodeTagsIcon);
Vue.component('cog-icon', CogIcon);
Vue.component('cursor-default-click-icon', CursorDefaultClickIcon);
Vue.component('content-copy-icon', ContentCopyIcon);
Vue.component('clipboard-plus-icon', ClipboardPlusIcon);
Vue.component('clipboard-plus-outline-icon', ClipboardPlusOutlineIcon);
Vue.component('delete-icon', DeleteIcon);
Vue.component('content-cut-icon', ContentCutIcon);
Vue.component('dots-vertical-icon', DotsVerticalIcon);
Vue.component('drag-icon', AppsIcon);
Vue.component('eye-icon', EyeIcon);
Vue.component('file-tree-icon', FileTreeIcon);
Vue.component('file-document-icon', FileDocumentIcon);
Vue.component('flare-icon', FlareIcon);
Vue.component('format-align-center-icon', FormatAlignCenterIcon);
Vue.component('format-align-justify-icon', FormatAlignJustifyIcon);
Vue.component('format-align-left-icon', FormatAlignLeftIcon);
Vue.component('format-align-right-icon', FormatAlignRightIcon);
Vue.component('format-bold-icon', FormatBoldIcon);
Vue.component('format-list-bulleted-icon', FormatListBulletedIcon);
Vue.component('format-list-numbered-icon', FormatListNumberedIcon);
Vue.component('format-italic-icon', FormatItalicIcon);
Vue.component('format-strikethrough-variant-icon', FormatStrikethroughVariantIcon);
Vue.component('format-underline-icon', FormatUnderlineIcon);
Vue.component('format-quote-close-icon', FormatQuoteCloseIcon);
Vue.component('help-circle-icon', HelpCircleIcon);
Vue.component('information-outline-icon', InformationOutlineIcon);
Vue.component('information-icon', InformationIcon);
Vue.component('image-icon', ImageIcon);
Vue.component('image-size-select-actual-icon', ImageSizeSelectActualIcon);
Vue.component('play-box-icon', PlayBoxIcon);
Vue.component('instagram-icon', InstagramIcon);
Vue.component('label-icon', LabelIcon);
Vue.component('lightbulb-on-icon', LightbulbOnIcon);
Vue.component('link-icon', LinkIcon);
Vue.component('list-status-icon', ListStatusIcon);
Vue.component('lock-icon', LockIcon);
Vue.component('map-marker-icon', MapMarkerIcon);
Vue.component('magnify-icon', MagnifyIcon);
Vue.component('menu-down-icon', MenuDownIcon);
Vue.component('minus-icon', MinusIcon);
Vue.component('minus-box-icon', MinusBoxIcon);
Vue.component('paperclip-icon', PaperclipIcon);
Vue.component('pencil-icon', PencilIcon);
Vue.component('plus-icon', PlusIcon);
Vue.component('phone-icon', PhoneIcon);
Vue.component('redo-icon', RedoVariantIcon);
Vue.component('refresh-icon', RefreshIcon);
Vue.component('sign-text-icon', SignTextIcon);
Vue.component('text-box-remove-icon', TextBoxRemoveIcon);
Vue.component('trash-can-icon', TrashCanIcon);
Vue.component('trash-can-outline-icon', TrashCanOutlineIcon);
Vue.component('tune-icon', TuneIcon);
Vue.component('undo-icon', UndoVariantIcon);
Vue.component('unfold-more-horizontal-icon', UnfoldMoreHorizontalIcon);
Vue.component('video-icon', VideoIcon);
Vue.component('view-column-icon', ViewColumnIcon);
Vue.component('web-icon', WebIcon);
Vue.component('database-export-icon', DatabaseExportIcon);
Vue.component('format-text-icon', FormatTextIcon);
Vue.component('format-color-highlight-icon', FormatColorHighlightIcon);
Vue.component('earth-icon', EarthIcon);
Vue.component('database-check-icon', DatabaseCheckIcon);
Vue.component('tray-full-icon', TrayFullIcon);

                
              import AposI18nLocalize from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/i18n/ui/apos/components/AposI18nLocalize.vue";
              

              import AposI18nLocalizeErrors from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/i18n/ui/apos/components/AposI18nLocalizeErrors.vue";
              

              import AposArrayEditor from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposArrayEditor.vue";
              

              import AposInputArea from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputArea.vue";
              

              import AposInputArray from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputArray.vue";
              

              import AposInputAttachment from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputAttachment.vue";
              

              import AposInputBoolean from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputBoolean.vue";
              

              import AposInputCheckboxes from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputCheckboxes.vue";
              

              import AposInputColor from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputColor.vue";
              

              import AposInputPassword from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputPassword.vue";
              

              import AposInputRadio from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputRadio.vue";
              

              import AposInputRange from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputRange.vue";
              

              import AposInputRelationship from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputRelationship.vue";
              

              import AposInputSelect from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputSelect.vue";
              

              import AposInputSlug from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputSlug.vue";
              

              import AposInputString from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputString.vue";
              

              import AposInputWrapper from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposInputWrapper.vue";
              

              import AposLogo from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposLogo.vue";
              

              import AposLogoIcon from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposLogoIcon.vue";
              

              import AposLogoPadless from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposLogoPadless.vue";
              

              import AposSchema from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposSchema.vue";
              

              import AposSearchList from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/schema/ui/apos/components/AposSearchList.vue";
              

              import AposInputRole from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/permission/ui/apos/components/AposInputRole.vue";
              

              import TheAposAdminBar from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/apos/components/TheAposAdminBar.vue";
              

              import TheAposAdminBarLocale from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/apos/components/TheAposAdminBarLocale.vue";
              

              import TheAposAdminBarMenu from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/apos/components/TheAposAdminBarMenu.vue";
              

              import TheAposAdminBarUser from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/apos/components/TheAposAdminBarUser.vue";
              

              import TheAposContextBar from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/apos/components/TheAposContextBar.vue";
              

              import TheAposContextModeAndSettings from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/apos/components/TheAposContextModeAndSettings.vue";
              

              import TheAposContextTitle from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/apos/components/TheAposContextTitle.vue";
              

              import TheAposContextUndoRedo from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/apos/components/TheAposContextUndoRedo.vue";
              

              import TheAposSavingIndicator from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/apos/components/TheAposSavingIndicator.vue";
              

              import AposNotification from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/notification/ui/apos/components/AposNotification.vue";
              

              import TheAposNotifications from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/notification/ui/apos/components/TheAposNotifications.vue";
              

              import TheAposLogin from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/login/ui/apos/components/TheAposLogin.vue";
              

              import TheAposLoginHeader from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/login/ui/apos/components/TheAposLoginHeader.vue";
              

              import AposDocsManagerToolbar from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/components/AposDocsManagerToolbar.vue";
              

              import AposModal from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/components/AposModal.vue";
              

              import AposModalBody from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/components/AposModalBody.vue";
              

              import AposModalBreadcrumbs from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/components/AposModalBreadcrumbs.vue";
              

              import AposModalConfirm from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/components/AposModalConfirm.vue";
              

              import AposModalLip from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/components/AposModalLip.vue";
              

              import AposModalRail from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/components/AposModalRail.vue";
              

              import AposModalTabs from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/components/AposModalTabs.vue";
              

              import AposModalTabsBody from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/components/AposModalTabsBody.vue";
              

              import AposModalToolbar from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/components/AposModalToolbar.vue";
              

              import TheAposModals from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/components/TheAposModals.vue";
              

              import AposDocContextMenu from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/doc-type/ui/apos/components/AposDocContextMenu.vue";
              

              import AposDocEditor from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/doc-type/ui/apos/components/AposDocEditor.vue";
              

              import AposDocsManager from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/piece-type/ui/apos/components/AposDocsManager.vue";
              

              import AposDocsManagerDisplay from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/piece-type/ui/apos/components/AposDocsManagerDisplay.vue";
              

              import AposDocsManagerSelectBox from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/piece-type/ui/apos/components/AposDocsManagerSelectBox.vue";
              

              import AposRelationshipEditor from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/piece-type/ui/apos/components/AposRelationshipEditor.vue";
              

              import AposPagesManager from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/page/ui/apos/components/AposPagesManager.vue";
              

              import AposAreaEditor from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/area/ui/apos/components/AposAreaEditor.vue";
              

              import AposAreaMenu from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/area/ui/apos/components/AposAreaMenu.vue";
              

              import AposAreaMenuItem from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/area/ui/apos/components/AposAreaMenuItem.vue";
              

              import AposAreaWidget from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/area/ui/apos/components/AposAreaWidget.vue";
              

              import AposWidgetControls from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/area/ui/apos/components/AposWidgetControls.vue";
              

              import AposWidget from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/widget-type/ui/apos/components/AposWidget.vue";
              

              import AposWidgetEditor from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/widget-type/ui/apos/components/AposWidgetEditor.vue";
              

              import AposRichTextWidget from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/components/AposRichTextWidget.vue";
              

              import AposRichTextWidgetEditor from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/components/AposRichTextWidgetEditor.vue";
              

              import AposTiptapButton from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/components/AposTiptapButton.vue";
              

              import AposTiptapDivider from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/components/AposTiptapDivider.vue";
              

              import AposTiptapLink from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/components/AposTiptapLink.vue";
              

              import AposTiptapStyles from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/components/AposTiptapStyles.vue";
              

              import AposTiptapTable from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/components/AposTiptapTable.vue";
              

              import AposTiptapUndefined from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/components/AposTiptapUndefined.vue";
              

              import AposInputOembed from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/oembed-field/ui/apos/components/AposInputOembed.vue";
              

              import AposAvatar from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposAvatar.vue";
              

              import AposButton from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposButton.vue";
              

              import AposButtonGroup from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposButtonGroup.vue";
              

              import AposButtonSplit from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposButtonSplit.vue";
              

              import AposCellBasic from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposCellBasic.vue";
              

              import AposCellButton from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposCellButton.vue";
              

              import AposCellContextMenu from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposCellContextMenu.vue";
              

              import AposCellDate from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposCellDate.vue";
              

              import AposCellLabels from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposCellLabels.vue";
              

              import AposCellLastEdited from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposCellLastEdited.vue";
              

              import AposCellLink from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposCellLink.vue";
              

              import AposCellType from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposCellType.vue";
              

              import AposCheckbox from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposCheckbox.vue";
              

              import AposCloudUploadIcon from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposCloudUploadIcon.vue";
              

              import AposContextMenu from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposContextMenu.vue";
              

              import AposContextMenuDialog from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposContextMenuDialog.vue";
              

              import AposContextMenuItem from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposContextMenuItem.vue";
              

              import AposContextMenuTip from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposContextMenuTip.vue";
              

              import AposEmptyState from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposEmptyState.vue";
              

              import AposFile from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposFile.vue";
              

              import AposFilterMenu from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposFilterMenu.vue";
              

              import AposIndicator from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposIndicator.vue";
              

              import AposLabel from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposLabel.vue";
              

              import AposLoading from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposLoading.vue";
              

              import AposMinMaxCount from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposMinMaxCount.vue";
              

              import AposPager from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposPager.vue";
              

              import AposPagerDots from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposPagerDots.vue";
              

              import AposSlat from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposSlat.vue";
              

              import AposSlatList from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposSlatList.vue";
              

              import AposSpinner from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposSpinner.vue";
              

              import AposTag from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposTag.vue";
              

              import AposTagApply from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposTagApply.vue";
              

              import AposTagList from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposTagList.vue";
              

              import AposTagListItem from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposTagListItem.vue";
              

              import AposTree from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposTree.vue";
              

              import AposTreeHeader from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposTreeHeader.vue";
              

              import AposTreeRows from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/components/AposTreeRows.vue";
              

              import AposMediaManager from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/image/ui/apos/components/AposMediaManager.vue";
              

              import AposMediaManagerDisplay from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/image/ui/apos/components/AposMediaManagerDisplay.vue";
              

              import AposMediaManagerEditor from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/image/ui/apos/components/AposMediaManagerEditor.vue";
              

              import AposMediaManagerSelections from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/image/ui/apos/components/AposMediaManagerSelections.vue";
              

              import AposMediaUploader from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/image/ui/apos/components/AposMediaUploader.vue";
              

              import AposSubmittedDraftIcon from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/submitted-draft/ui/apos/components/AposSubmittedDraftIcon.vue";
              

              import TheAposBusy from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/busy/ui/apos/components/TheAposBusy.vue";
              

                
              import Classes from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/tiptap-extensions/Classes.js";
              

              import Default from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/tiptap-extensions/Default.js";
              

              import Document from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/tiptap-extensions/Document.js";
              

              import Heading from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/tiptap-extensions/Heading.js";
              

              import Link from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/tiptap-extensions/Link.js";
              

              import TextStyle from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/rich-text-widget/ui/apos/tiptap-extensions/TextStyle.js";
              

                
              import AposI18nCrossDomainSession_0App from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/i18n/ui/apos/apps/AposI18nCrossDomainSession.js";
              

              import AposAdminBar_1App from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/admin-bar/ui/apos/apps/AposAdminBar.js";
              

              import AposNotification_2App from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/notification/ui/apos/apps/AposNotification.js";
              

              import AposLogin_3App from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/login/ui/apos/apps/AposLogin.js";
              

              import AposModals_4App from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/modal/ui/apos/apps/AposModals.js";
              

              import AposAreas_5App from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/area/ui/apos/apps/AposAreas.js";
              

              import AposBusEvent_6App from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/ui/ui/apos/apps/AposBusEvent.js";
              

              import AposBusy_7App from "/var/www/nodejs/erp.aero/node_modules/apostrophe/modules/@apostrophecms/busy/ui/apos/apps/AposBusy.js";
              

                
                
                Vue.component('account-box-icon', AccountBoxIcon);
Vue.component('alpha-x-icon', AlphaXIcon);
Vue.component('alert-circle-icon', AlertCircleIcon);
Vue.component('arrow-down-icon', ArrowDownIcon);
Vue.component('arrow-up-icon', ArrowUpIcon);
Vue.component('archive-arrow-down-icon', ArchiveArrowDownIcon);
Vue.component('archive-arrow-up-icon', ArchiveArrowUpIcon);
Vue.component('arrow-right-icon', ArrowRightIcon);
Vue.component('calendar-icon', CalendarIcon);
Vue.component('checkbox-blank-icon', CheckboxBlankOutlineIcon);
Vue.component('check-all-icon', CheckAllIcon);
Vue.component('check-bold-icon', CheckBoldIcon);
Vue.component('check-circle-icon', CheckCircleIcon);
Vue.component('check-decagram-icon', CheckDecagramIcon);
Vue.component('checkbox-marked-icon', CheckboxMarkedIcon);
Vue.component('chevron-down-icon', ChevronDownIcon);
Vue.component('chevron-left-icon', ChevronLeftIcon);
Vue.component('chevron-right-icon', ChevronRightIcon);
Vue.component('chevron-up-icon', ChevronUpIcon);
Vue.component('circle-icon', CircleIcon);
Vue.component('circle-medium-icon', CircleMediumIcon);
Vue.component('clock-icon', ClockIcon);
Vue.component('close-circle-icon', CloseCircleIcon);
Vue.component('close-icon', CloseIcon);
Vue.component('cloud-upload-icon', CloudUploadIcon);
Vue.component('code-tags-icon', CodeTagsIcon);
Vue.component('cog-icon', CogIcon);
Vue.component('cursor-default-click-icon', CursorDefaultClickIcon);
Vue.component('content-copy-icon', ContentCopyIcon);
Vue.component('clipboard-plus-icon', ClipboardPlusIcon);
Vue.component('clipboard-plus-outline-icon', ClipboardPlusOutlineIcon);
Vue.component('delete-icon', DeleteIcon);
Vue.component('content-cut-icon', ContentCutIcon);
Vue.component('dots-vertical-icon', DotsVerticalIcon);
Vue.component('drag-icon', AppsIcon);
Vue.component('eye-icon', EyeIcon);
Vue.component('file-tree-icon', FileTreeIcon);
Vue.component('file-document-icon', FileDocumentIcon);
Vue.component('flare-icon', FlareIcon);
Vue.component('format-align-center-icon', FormatAlignCenterIcon);
Vue.component('format-align-justify-icon', FormatAlignJustifyIcon);
Vue.component('format-align-left-icon', FormatAlignLeftIcon);
Vue.component('format-align-right-icon', FormatAlignRightIcon);
Vue.component('format-bold-icon', FormatBoldIcon);
Vue.component('format-list-bulleted-icon', FormatListBulletedIcon);
Vue.component('format-list-numbered-icon', FormatListNumberedIcon);
Vue.component('format-italic-icon', FormatItalicIcon);
Vue.component('format-strikethrough-variant-icon', FormatStrikethroughVariantIcon);
Vue.component('format-underline-icon', FormatUnderlineIcon);
Vue.component('format-quote-close-icon', FormatQuoteCloseIcon);
Vue.component('help-circle-icon', HelpCircleIcon);
Vue.component('information-outline-icon', InformationOutlineIcon);
Vue.component('information-icon', InformationIcon);
Vue.component('image-icon', ImageIcon);
Vue.component('image-size-select-actual-icon', ImageSizeSelectActualIcon);
Vue.component('play-box-icon', PlayBoxIcon);
Vue.component('instagram-icon', InstagramIcon);
Vue.component('label-icon', LabelIcon);
Vue.component('lightbulb-on-icon', LightbulbOnIcon);
Vue.component('link-icon', LinkIcon);
Vue.component('list-status-icon', ListStatusIcon);
Vue.component('lock-icon', LockIcon);
Vue.component('map-marker-icon', MapMarkerIcon);
Vue.component('magnify-icon', MagnifyIcon);
Vue.component('menu-down-icon', MenuDownIcon);
Vue.component('minus-icon', MinusIcon);
Vue.component('minus-box-icon', MinusBoxIcon);
Vue.component('paperclip-icon', PaperclipIcon);
Vue.component('pencil-icon', PencilIcon);
Vue.component('plus-icon', PlusIcon);
Vue.component('phone-icon', PhoneIcon);
Vue.component('redo-icon', RedoVariantIcon);
Vue.component('refresh-icon', RefreshIcon);
Vue.component('sign-text-icon', SignTextIcon);
Vue.component('text-box-remove-icon', TextBoxRemoveIcon);
Vue.component('trash-can-icon', TrashCanIcon);
Vue.component('trash-can-outline-icon', TrashCanOutlineIcon);
Vue.component('tune-icon', TuneIcon);
Vue.component('undo-icon', UndoVariantIcon);
Vue.component('unfold-more-horizontal-icon', UnfoldMoreHorizontalIcon);
Vue.component('video-icon', VideoIcon);
Vue.component('view-column-icon', ViewColumnIcon);
Vue.component('web-icon', WebIcon);
Vue.component('database-export-icon', DatabaseExportIcon);
Vue.component('format-text-icon', FormatTextIcon);
Vue.component('format-color-highlight-icon', FormatColorHighlightIcon);
Vue.component('earth-icon', EarthIcon);
Vue.component('database-check-icon', DatabaseCheckIcon);
Vue.component('tray-full-icon', TrayFullIcon);

                Vue.component("AposI18nLocalize", AposI18nLocalize);
Vue.component("AposI18nLocalizeErrors", AposI18nLocalizeErrors);
Vue.component("AposArrayEditor", AposArrayEditor);
Vue.component("AposInputArea", AposInputArea);
Vue.component("AposInputArray", AposInputArray);
Vue.component("AposInputAttachment", AposInputAttachment);
Vue.component("AposInputBoolean", AposInputBoolean);
Vue.component("AposInputCheckboxes", AposInputCheckboxes);
Vue.component("AposInputColor", AposInputColor);
Vue.component("AposInputPassword", AposInputPassword);
Vue.component("AposInputRadio", AposInputRadio);
Vue.component("AposInputRange", AposInputRange);
Vue.component("AposInputRelationship", AposInputRelationship);
Vue.component("AposInputSelect", AposInputSelect);
Vue.component("AposInputSlug", AposInputSlug);
Vue.component("AposInputString", AposInputString);
Vue.component("AposInputWrapper", AposInputWrapper);
Vue.component("AposLogo", AposLogo);
Vue.component("AposLogoIcon", AposLogoIcon);
Vue.component("AposLogoPadless", AposLogoPadless);
Vue.component("AposSchema", AposSchema);
Vue.component("AposSearchList", AposSearchList);
Vue.component("AposInputRole", AposInputRole);
Vue.component("TheAposAdminBar", TheAposAdminBar);
Vue.component("TheAposAdminBarLocale", TheAposAdminBarLocale);
Vue.component("TheAposAdminBarMenu", TheAposAdminBarMenu);
Vue.component("TheAposAdminBarUser", TheAposAdminBarUser);
Vue.component("TheAposContextBar", TheAposContextBar);
Vue.component("TheAposContextModeAndSettings", TheAposContextModeAndSettings);
Vue.component("TheAposContextTitle", TheAposContextTitle);
Vue.component("TheAposContextUndoRedo", TheAposContextUndoRedo);
Vue.component("TheAposSavingIndicator", TheAposSavingIndicator);
Vue.component("AposNotification", AposNotification);
Vue.component("TheAposNotifications", TheAposNotifications);
Vue.component("TheAposLogin", TheAposLogin);
Vue.component("TheAposLoginHeader", TheAposLoginHeader);
Vue.component("AposDocsManagerToolbar", AposDocsManagerToolbar);
Vue.component("AposModal", AposModal);
Vue.component("AposModalBody", AposModalBody);
Vue.component("AposModalBreadcrumbs", AposModalBreadcrumbs);
Vue.component("AposModalConfirm", AposModalConfirm);
Vue.component("AposModalLip", AposModalLip);
Vue.component("AposModalRail", AposModalRail);
Vue.component("AposModalTabs", AposModalTabs);
Vue.component("AposModalTabsBody", AposModalTabsBody);
Vue.component("AposModalToolbar", AposModalToolbar);
Vue.component("TheAposModals", TheAposModals);
Vue.component("AposDocContextMenu", AposDocContextMenu);
Vue.component("AposDocEditor", AposDocEditor);
Vue.component("AposDocsManager", AposDocsManager);
Vue.component("AposDocsManagerDisplay", AposDocsManagerDisplay);
Vue.component("AposDocsManagerSelectBox", AposDocsManagerSelectBox);
Vue.component("AposRelationshipEditor", AposRelationshipEditor);
Vue.component("AposPagesManager", AposPagesManager);
Vue.component("AposAreaEditor", AposAreaEditor);
Vue.component("AposAreaMenu", AposAreaMenu);
Vue.component("AposAreaMenuItem", AposAreaMenuItem);
Vue.component("AposAreaWidget", AposAreaWidget);
Vue.component("AposWidgetControls", AposWidgetControls);
Vue.component("AposWidget", AposWidget);
Vue.component("AposWidgetEditor", AposWidgetEditor);
Vue.component("AposRichTextWidget", AposRichTextWidget);
Vue.component("AposRichTextWidgetEditor", AposRichTextWidgetEditor);
Vue.component("AposTiptapButton", AposTiptapButton);
Vue.component("AposTiptapDivider", AposTiptapDivider);
Vue.component("AposTiptapLink", AposTiptapLink);
Vue.component("AposTiptapStyles", AposTiptapStyles);
Vue.component("AposTiptapTable", AposTiptapTable);
Vue.component("AposTiptapUndefined", AposTiptapUndefined);
Vue.component("AposInputOembed", AposInputOembed);
Vue.component("AposAvatar", AposAvatar);
Vue.component("AposButton", AposButton);
Vue.component("AposButtonGroup", AposButtonGroup);
Vue.component("AposButtonSplit", AposButtonSplit);
Vue.component("AposCellBasic", AposCellBasic);
Vue.component("AposCellButton", AposCellButton);
Vue.component("AposCellContextMenu", AposCellContextMenu);
Vue.component("AposCellDate", AposCellDate);
Vue.component("AposCellLabels", AposCellLabels);
Vue.component("AposCellLastEdited", AposCellLastEdited);
Vue.component("AposCellLink", AposCellLink);
Vue.component("AposCellType", AposCellType);
Vue.component("AposCheckbox", AposCheckbox);
Vue.component("AposCloudUploadIcon", AposCloudUploadIcon);
Vue.component("AposContextMenu", AposContextMenu);
Vue.component("AposContextMenuDialog", AposContextMenuDialog);
Vue.component("AposContextMenuItem", AposContextMenuItem);
Vue.component("AposContextMenuTip", AposContextMenuTip);
Vue.component("AposEmptyState", AposEmptyState);
Vue.component("AposFile", AposFile);
Vue.component("AposFilterMenu", AposFilterMenu);
Vue.component("AposIndicator", AposIndicator);
Vue.component("AposLabel", AposLabel);
Vue.component("AposLoading", AposLoading);
Vue.component("AposMinMaxCount", AposMinMaxCount);
Vue.component("AposPager", AposPager);
Vue.component("AposPagerDots", AposPagerDots);
Vue.component("AposSlat", AposSlat);
Vue.component("AposSlatList", AposSlatList);
Vue.component("AposSpinner", AposSpinner);
Vue.component("AposTag", AposTag);
Vue.component("AposTagApply", AposTagApply);
Vue.component("AposTagList", AposTagList);
Vue.component("AposTagListItem", AposTagListItem);
Vue.component("AposTree", AposTree);
Vue.component("AposTreeHeader", AposTreeHeader);
Vue.component("AposTreeRows", AposTreeRows);
Vue.component("AposMediaManager", AposMediaManager);
Vue.component("AposMediaManagerDisplay", AposMediaManagerDisplay);
Vue.component("AposMediaManagerEditor", AposMediaManagerEditor);
Vue.component("AposMediaManagerSelections", AposMediaManagerSelections);
Vue.component("AposMediaUploader", AposMediaUploader);
Vue.component("AposSubmittedDraftIcon", AposSubmittedDraftIcon);
Vue.component("TheAposBusy", TheAposBusy);

                apos.tiptapExtensions = apos.tiptapExtensions || [];
apos.tiptapExtensions.push(Classes);apos.tiptapExtensions = apos.tiptapExtensions || [];
apos.tiptapExtensions.push(Default);apos.tiptapExtensions = apos.tiptapExtensions || [];
apos.tiptapExtensions.push(Document);apos.tiptapExtensions = apos.tiptapExtensions || [];
apos.tiptapExtensions.push(Heading);apos.tiptapExtensions = apos.tiptapExtensions || [];
apos.tiptapExtensions.push(Link);apos.tiptapExtensions = apos.tiptapExtensions || [];
apos.tiptapExtensions.push(TextStyle);setTimeout(() => {
                    AposI18nCrossDomainSession_0App();
AposAdminBar_1App();
AposNotification_2App();
AposLogin_3App();
AposModals_4App();
AposAreas_5App();
AposBusEvent_6App();
AposBusy_7App();

                  }, 0);